import { Dispatch, SetStateAction, useState, useEffect } from "react";
import Modal from "@components/common/modal";
import Input from "@components/common/input";
import { useDebounce } from "@vhows/util";
import CommonButton from "@components/common/button";

interface Props {
  fetchData: (text: string) => Promise<any>;
  setData: (data: any) => void;
  isVisible: boolean;
  handleClose: Dispatch<SetStateAction<boolean>>;
}

export default function PopUpSearch({ fetchData, setData, isVisible, handleClose }: Props) {
  const [search, setSearch] = useState("");
  const [list, setList] = useState([]);
  const [listSize, setListSize] = useState(9);
  const debounce = useDebounce(search, 300);

  useEffect(() => {
    if (debounce) {
      fetchData(debounce).then(result => {
        setList(result);
        setListSize(9);
      });
    } else {
      setList([]);
      setListSize(9);
    }
  }, [debounce]);

  const handleMore = () => {
    setListSize(prev => prev + 9);
  };

  const handleSubmit = (v: any) => {
    setData(v);
    handleClose(false);
  };

  return (
    <>
      <Modal
        open={isVisible}
        onClose={e => {
          handleClose(false);
        }}
        mode="onlyCancel"
      >
        <>
          <h2 className="text-lg">고객 검색</h2>
          <Input className="mt-2" value={search} onChange={e => setSearch(e.target.value)} />
          <div className="mt-3 max-h-[500px] overflow-y-auto">
            {list.slice(0, listSize).map(v => (
              <div
                key={v.id}
                className="flex flex-col border-y p-2 cursor-pointer hover:bg-gray-200"
                onClick={() => handleSubmit(v)}
              >
                <h4>{v.name}</h4>
                <span>{v.mobileNumber}</span>
              </div>
            ))}
            {list.length > listSize + 1 && (
              <div className="flex justify-center mt-3">
                <CommonButton color="white" className="w-24 h-[34px]" onClick={() => handleMore()}>
                  더보기
                </CommonButton>
              </div>
            )}
            {!list.length && <div className="flex justify-center mt-3 text-lg">결과 없음</div>}
          </div>
        </>
      </Modal>
    </>
  );
}
